import React from 'react';
import SlideToggle from '../SlideToggle';
import useUser from '../../Hooks/useUser';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export const AdminToggle = ({ fontSize }) => {
  const { userView, handleUserViewChange } = useUser();
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className={'mx-auto mt-2'}>
      <SlideToggle
        value={userView}
        onChange={(value) => handleUserViewChange(value, () => navigate('/'))}
        fontSize={fontSize}
      >
        {t('userView')}
      </SlideToggle>
    </div>
  );
};
